import { OrgUserUpdate, Persona } from '@cibo/core'
import { Grid } from '@mui/material'
import { useFormikContext } from 'formik'
import { useAuth, usePermissions } from '../../hooks'
import { AuthUserPermission } from '../../types'
import { PersonaCards } from './PersonaCards'

const personasToDisplay: Record<Persona, Persona[]> = {
  grower: [],
  advisor: ['grower', 'advisor'],
  admin: ['grower', 'advisor', 'admin'],
}

export const PersonaCardsInput = ({
  isSelf,
  showPersonaField,
  disabled,
}: {
  isSelf?: boolean
  disabled?: boolean
  showPersonaField?: boolean
}) => {
  const { persona } = useAuth()
  const { can } = usePermissions()
  const { isSubmitting, setFieldValue, values } = useFormikContext<OrgUserUpdate>()
  return !isSelf && can({ useAny: AuthUserPermission.VIEW_USER_PERMISSION }) ? (
    <Grid item xs={12}>
      {!!persona && showPersonaField && (
        <PersonaCards
          disabled={
            isSelf ||
            disabled ||
            isSubmitting ||
            !can({ useAny: AuthUserPermission.EDIT_USER_PERMISSION })
          }
          personas={personasToDisplay[persona]}
          activePersona={values.persona}
          onClick={persona => setFieldValue('persona', persona, true)}
        />
      )}
    </Grid>
  ) : null
}
